import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Icon from 'svg-inline-react'

import styles from './style.styl'

import WIDGET_SIZE_SMALL from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-option-small.svg'
import WIDGET_SIZE_LARGE from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/widget-option-large.svg'

class WidgetSizePicker extends Component {
  static propTypes = {
    widgetHalfHeight: PropTypes.bool,
    onSelection: PropTypes.func,
  }

  changeWidgetHeight(isHalfHeight) {
    const { onSelection } = this.props
    onSelection(isHalfHeight, true)
  }

  render() {
    const { widgetHalfHeight } = this.props
    return (
      <div className={styles.WidgetSizePicker}>
        <div className="widget-size-option-container">
          <div
            className={cx('widget-size-option', { active: !widgetHalfHeight })}
            onClick={() => this.changeWidgetHeight(false)}
          >
            <Icon src={WIDGET_SIZE_LARGE} />
            <span className="widget-size-option-label">Large</span>
          </div>
        </div>
        <div className="widget-size-option-container">
          <div
            className={cx('widget-size-option', { active: widgetHalfHeight })}
            onClick={() => this.changeWidgetHeight(true)}
          >
            <Icon src={WIDGET_SIZE_SMALL} />
            <span className="widget-size-option-label">Small</span>
          </div>
        </div>
      </div>
    )
  }
}

export default WidgetSizePicker



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/WidgetSizePicker/index.js